import {
  Button,
  Card,
  Container,
  FormControl,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getEmployee } from "../../../redux/reducer/employee/employeeReducer";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import { getRole } from "../../../redux/reducer/role/roleReducer";
import {
  getUserManagementById,
  updateUserManagement,
  userManagementActions,
} from "../../../redux/reducer/userManagement/userManagementReducer";

const useStyle = makeStyles(() => ({
  titleCard: {
    marginTop: "20px",
    padding: "10px",
    background: "#F2F2F2",
  },
  formControlStyle: {
    display: "flex",
    alignItems: "center",
    justifyItems: "flex-start",
    width: "100%",
    margin: "10px 0px",
    flexDirection: "row",
    background: "none",
  },
}));

export default function UserManagamentEdit() {
  // Route
  const navigate = useNavigate();
  const { id } = useParams();

  // Material UI
  const styles = useStyle();

  // Redux State
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const role = useSelector((state) => state.role.data);
  const employee = useSelector((state) => state.employee.data);
  const farmer = useSelector((state) => state.farmer.data);
  const user = useSelector((state) => state.userManagement.data);

  // Local State
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    roleId: "",
    roleName: "",
    sourceType: "",
    employeeId: "",
    employeeName: "",
    farmerId: "",
    farmerName: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      let x = user.docs.findIndex((item) => item._id === id);
      if (x !== -1) {
        setFormData({
          username: user.docs[x].username ? user.docs[x].username : "",
          password: user.docs[x].password ? user.docs[x].password : "",
          roleId: user.docs[x].roleId ? user.docs[x].roleId : "",
          roleName: user.docs[x].roleId ? user.docs[x].roleId.roleName : "",
          sourceType: user.docs[x].source ? user.docs[x].source.sourceType : "",
          employeeId: user.docs[x].source?.employeeId ? user.docs[x].source.employeeId._id : "",
          employeeName: user.docs[x].source?.employeeId
            ? user.docs[x].source.employeeId.fullName
            : "",
          farmerId: user.docs[x].source?.farmerId ? user.docs[x].source.farmerId._id : "",
          farmerName: user.docs[x].source?.farmerId
            ? user.docs[x].source.farmerId?.fullName
            : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  console.log(formData);

  // Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (role.totalDocs !== role.docs.length && value === 1) {
        const getData = {
          params: {
            limit: role.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getRole(getData));
      } else if (
        (employee.totalDocs !== employee.docs.length && value === 2) ||
        (farmer.totalDocs !== farmer.docs.length && value === 2)
      ) {
        if (formData.sourceType === "employee") {
          const getData = {
            params: {
              limit: employee.limit + 10,
              page: 1,
            },
            token: token,
          };
          dispatch(getEmployee(getData));
        } else if (formData.sourceType === "farmer") {
          const getData = {
            params: {
              limit: farmer.limit + 10,
              page: 1,
            },
            token: token,
          };
          dispatch(getFarmer(getData));
        }
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            username: formData.username,
            password: formData.password,
            roleId: formData.roleId,
            source: {
              sourceType: formData.sourceType,
              [formData.sourceType === "employee" ? "employeeId" : "farmerId"]:
                formData.sourceType === "employee"
                  ? formData.employeeId
                  : formData.farmerId,
            },
          },
          token: token,
          id: id,
        };
        dispatch(updateUserManagement(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getUserManagementById(dataGetById)).then((res) => {
              if (res) {
                dispatch(
                  userManagementActions.editUserManagement(res.payload.data)
                );
                navigate("/admin/user-management");
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: res.payload.message,
            });
          }
        });
      }
    });
  };

  return (
    <Container>
      <Card className={styles.titleCard}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          Edit User
        </Typography>
      </Card>
      <Card className={styles.titleCard}>
        <form onSubmit={handleSubmit}>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              Username
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 15,
                style: { background: "white" },
              }}
              required
              helperText={
                formData.username.length > 0
                  ? formData.username.length < 4
                    ? "Password harus melebihi 14 karakter"
                    : ""
                  : ""
              }
              size="small"
              error={
                formData.username.length > 0
                  ? formData.username.length < 4
                    ? true
                    : false
                  : false
              }
              name="username"
              onChange={handleChange}
              value={formData.username}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              ROLE
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              select
              required
              size="small"
              error={false}
              name="roleId"
              onChange={handleChange}
              value={formData.roleId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.roleId ? (
                <MenuItem value={formData.roleId}>{formData.roleName}</MenuItem>
              ) : (
                ""
              )}
              {role.docs.length > 0 ? (
                role.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.roleName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              Karyawan
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              select
              required
              size="small"
              error={false}
              name="sourceType"
              onChange={handleChange}
              value={formData.sourceType}
              variant="outlined"
              style={{
                maxWidth: "400px",
                minWidth: "140px",
                background: "white",
                marginRight: "10px",
              }}
            >
              <MenuItem value="employee">Karyawan</MenuItem>
              <MenuItem value="farmer">Petani</MenuItem>
            </TextField>
            {formData.sourceType === "employee" ? (
              <TextField
                InputLabelProps={{ shrink: true }}
                select
                required
                size="small"
                error={false}
                name="employeeId"
                onChange={handleChange}
                value={formData.employeeId}
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(2),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  width: "250px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.employeeName && formData.employeeId.length > 0 ? (
                  <MenuItem value={formData.employeeId}>
                    {formData.employeeName}
                  </MenuItem>
                ) : (
                  ""
                )}
                {employee.docs.length > 0 ? (
                  employee.docs.map(
                    (data, index) =>
                      (
                        <MenuItem value={data._id} key={index}>
                          {data.fullName}
                        </MenuItem>
                      )
                  )
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            ) : (
              ""
            )}
            {formData.sourceType === "farmer" ? (
              <TextField
                InputLabelProps={{ shrink: true }}
                select
                required
                size="small"
                error={false}
                name="farmerId"
                onChange={handleChange}
                value={formData.farmerId}
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      onScroll: loadMore(2),
                    },
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  width: "250px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.farmerName && formData.farmerId.length > 0 ? (
                  <MenuItem value={formData.farmerId}>
                    {formData.farmerName}
                  </MenuItem>
                ) : (
                  ""
                )}
                {farmer.docs.length > 0 ? (
                  farmer.docs.map(
                    (data, index) =>
                      (
                        <MenuItem value={data._id} key={index}>
                          {data.fullName}
                        </MenuItem>
                      )
                  )
                ) : (
                  <MenuItem value="">Data kosong</MenuItem>
                )}
              </TextField>
            ) : (
              ""
            )}
          </FormControl>

          <div>
            <Button type="submit" variant="contained">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: 5 }}
              onClick={() => navigate("/admin/user-management")}
            >
              CANCEL
            </Button>
          </div>
        </form>
      </Card>
    </Container>
  );
}
